import FeedbackActions from "ds/components/Feedback/Actions";
import LinkButton from "ds/components/Button/LinkButton";
import { External } from "components/icons/generated";

type StatusCheckFixButtonProps = {
  appUrl: string;
};

const StatusCheckFixButton = ({ appUrl }: StatusCheckFixButtonProps) => {
  return (
    <FeedbackActions>
      <LinkButton variant="contrast" size="small" href={appUrl} endIcon={External} target="_blank">
        Fix on GitHub
      </LinkButton>
    </FeedbackActions>
  );
};

export default StatusCheckFixButton;
